import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { SubjectIcon } from "@/components/SubjectIcon";
import { remap } from "@/lib/palette";
import { ArrowRight, Stack } from "@phosphor-icons/react";

export default function Filieres() {
  const [filieres, setFilieres] = useState([]);
  useEffect(() => { api.get("/filieres").then((r) => setFilieres(r.data)); }, []);

  return (
    <div className="space-y-8">
      <div className="animate-fade-up">
        <span className="text-xs font-semibold uppercase tracking-[0.25em] text-terracotta">Enseignement technique & professionnel</span>
        <h1 className="mt-2 font-display text-3xl font-extrabold sm:text-4xl">Filières techniques</h1>
        <p className="mt-1 text-ink/65">Séries, classes et matières professionnelles conformes aux référentiels officiels.</p>
      </div>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {filieres.map((f) => (
          <Link key={f.id} to={`/app/filieres/${f.id}`} data-testid={`filiere-card-${f.id}`}
            className="group rounded-2xl border border-border bg-white p-6 transition hover:-translate-y-1 hover:shadow-[0_14px_34px_rgba(4,42,101,0.1)]">
            <div className="grid h-12 w-12 place-items-center rounded-xl" style={{ background: `${remap(f.color)}1a`, color: remap(f.color) }}>
              <SubjectIcon name={f.icon} size={26} />
            </div>
            <div className="mt-4 font-display text-lg font-bold">{f.name}</div>
            <div className="mt-2 flex flex-wrap gap-1.5">
              {f.series.map((s) => (
                <span key={s.code} className="rounded-full bg-sand px-2.5 py-0.5 text-xs font-semibold text-forest">{s.code}</span>
              ))}
            </div>
            <div className="mt-3 text-sm text-muted-foreground">{f.subjects.length} matières professionnelles</div>
            <div className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-terracotta">Détails <ArrowRight className="transition group-hover:translate-x-1" /></div>
          </Link>
        ))}
      </div>
    </div>
  );
}
